import { render, staticRenderFns } from "./show-mp4.vue?vue&type=template&id=15eb83b0&scoped=true"
import script from "./show-mp4.vue?vue&type=script&lang=js"
export * from "./show-mp4.vue?vue&type=script&lang=js"
import style0 from "./show-mp4.vue?vue&type=style&index=0&id=15eb83b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eb83b0",
  null
  
)

export default component.exports